/**
 * Paste languages whose highlighting is provided by a differently named Monaco language. Ids
 * Monaco does not know at all (e.g. awk) simply render without highlighting.
 */
const MONACO_ALIASES: Readonly<Record<string, string>> = {
  bash: 'shell',
};

export function monacoLanguageOf(language: string): string {
  return MONACO_ALIASES[language] ?? language;
}
